import img1 from "../../assets/gallery/gallery1.webp";
import img2 from "../../assets/gallery/gallery2.webp";
import img3 from "../../assets/gallery/gallery3.webp";
import img4 from "../../assets/gallery/gallery4.webp";
import img5 from "../../assets/gallery/gallery5.webp";
import img6 from "../../assets/gallery/gallery6.webp";
import img7 from "../../assets/gallery/gallery7.webp";
import img8 from "../../assets/gallery/gallery8.webp";
import img9 from "../../assets/gallery/gallery9.webp";
import img10 from "../../assets/gallery/gallery10.webp";
import img11 from "../../assets/gallery/gallery11.webp";
import img12 from "../../assets/gallery/gallery12.webp";
import img13 from "../../assets/gallery/gallery13.webp";
import img14 from "../../assets/gallery/gallery14.webp";
import img15 from "../../assets/gallery/gallery15.webp";
import img16 from "../../assets/gallery/gallery16.webp";
import img17 from "../../assets/gallery/gallery17.webp";
import img18 from "../../assets/gallery/gallery18.webp";
import img19 from "../../assets/gallery/gallery19.webp";
import img20 from "../../assets/gallery/gallery20.webp";
import img21 from "../../assets/gallery/gallery21.webp";
import img22 from "../../assets/gallery/gallery22.webp";

const CARS = [
	{ id: 1, src: img1, model: "VOLKSWAGEN GOL" },
	{ id: 2, src: img2, model: "VW SAVEIRO ROBUST" },
	{ id: 3, src: img3, model: "CHEVROLET TORNADO" },
	{ id: 4, src: img4, model: "CHEVROLET SPARK LS" },
	{ id: 5, src: img5, model: "SEAT CORDOBA" },
	{ id: 6, src: img6, model: "SEA RAY" },
	{ id: 7, src: img7, model: "BMW Z4" },
	{ id: 8, src: img8, model: "CHEVROLET MATIZ" },
	{ id: 9, src: img9, model: "CORVETTE CONVERTIBLE" },
	{ id: 10, src: img10, model: "RAV 4 TOYOTA" },
	{ id: 11, src: img11, model: "PORSCHE BOXER" },
	{ id: 12, src: img12, model: "OROCH RENAULT" },
	{ id: 13, src: img13, model: "MINI COOPER SALT" },
	{ id: 14, src: img14, model: "MERCEDES BENZ SLK 350" },
	{ id: 15, src: img15, model: "HIACE TOYOTA" },
	{ id: 16, src: img16, model: "JEEP GRAND CHEROKEE" },
	{ id: 17, src: img17, model: "JEEP GRAND CHEROKEE BLINDADA" },
	{ id: 18, src: img18, model: "GENERAL MOTORS CHEVY" },
	{ id: 19, src: img19, model: "AUDI TT COUPE" },
	{ id: 20, src: img20, model: "FORD F 250 XLT" },
	{ id: 21, src: img21, model: "ESCALADE" },
	{ id: 22, src: img22, model: "BARCO MONTERREY" },
];

export default function Gallery() {
	return (
		<div className="p-5 sm:p-8">
			<div className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 space-y-4">
				{CARS.map((car, index) => (
					<div
						key={car.id}
						className="relative group break-inside-avoid overflow-hidden rounded-xl shadow-lg"
					>
						<img
							src={car.src}
							alt={`Galería de autos - ${car.id}`}
							loading="lazy"
							className="w-full h-auto object-cover transform transition-transform duration-500 group-hover:scale-110"
						/>

						<div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
							<span className="text-white font-semibold text-lg tracking-wider border border-white/50 px-4 py-2 rounded-lg backdrop-blur-sm text-center">
								{car.model}
							</span>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
